import axios from 'axios'
import last from 'lodash/last'
import get from 'lodash/get'

const URL = 'https://tiempos-de-espera-api-thrumming-snow-1094.fly.dev'

const ESTADOS = {
  '1': 'A la espera de referencia',
  '2': 'A la espera de revisión',
  '3': 'A la espera de priorización',
  '4': 'A la espera de agendamiento',
  '5': 'En espera de la atención',
  '6': 'A la espera de cierre',
  '7': 'Cerrada',
}

export async function getServiceRequest(id) {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${URL}/ServiceRequest/${id}/_history`,
  };

  const response = await axios.request(config)
  const data = []

  for (let i = 0; i < response.data.entry.length; i++) {
    const element = response.data.entry[i].resource;
    const codigoEstado = last(element.extension.filter(element => element.url === 'https://interoperabilidad.minsal.cl/fhir/ig/tei/StructureDefinition/EstadoInterconsultaCodigoLE')).valueCodeableConcept.coding[0].code
    const estadoInterconsulta = ESTADOS[codigoEstado]

    data.push({
      id: element.meta.versionId,
      intent: element.intent,
      status: element.status,
      subject: element.subject.reference,
      estadoInterconsulta,
      lastUpdated: element.meta.lastUpdated,
    })
  }

  const patient = await getPatient(get(data, '[0].subject'))

  return {
    serviceRequests: data,
    patient: {
      id: patient.id,
      birthDate: patient.birthDate,
      gender: patient.gender,
      name: `${get(patient, 'name[0].given[0]')} ${get(patient, 'name[0]._family.extension[0].valueString')} ${get(patient, 'name[0].family')}`,
      rut: `${get(patient, 'identifier[0].value')}-${get(patient, 'identifier[0].extension[0].valueString', '')}`,
    },
  }
}

export async function getPatient(id) {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${URL}/${id}`,
  };

  const response = await axios.request(config)
  const data = response.data
  return data
}
